import { createListFilters } from '../../../../../components'

export type ApiEmpresasFilters = {
  /** Nome fantasia ou razão social (busca parcial). */
  empresa: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<ApiEmpresasFilters>({
  empresa: '',
})
